import React from 'react';
import { Formik, Form, Field } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { TransitionItem } from '~helpers';
import { FormInput } from '~form';
import { Small } from '~typography';
import { Button, buttonBtnTypeData, buttonSkinData } from '~button';
import { AlertFeedback, alertPropTypes } from '~alert';
import FormContainer from './FormContainer';
import FieldContainer from './FieldContainer';
import FormMailingListNote from './FormMailingListNote';
import formMailingListSignup from '../schema/formMailingListSignup';

var FormMailingList = function FormMailingList(_ref) {
  var inPropFeedback = _ref.inPropFeedback,
      feedbackType = _ref.feedbackType,
      feedbackMessage = _ref.feedbackMessage,
      inProp = _ref.inProp,
      isLoading = _ref.isLoading,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      _onSubmit = _ref.onSubmit,
      resetFormTimeout = _ref.resetFormTimeout;
  var intl = useIntl();
  var initialValues = {
    emailAddressMailingList: ''
  };
  return /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(AlertFeedback, {
    inProp: inPropFeedback,
    alertType: feedbackType,
    alertMessage: feedbackMessage
  }), /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: inProp,
    appear: true
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: formMailingListSignup,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: function onSubmit(values, _ref2) {
      var resetForm = _ref2.resetForm;

      _onSubmit(values);

      setTimeout(function () {
        resetForm(initialValues);
      }, resetFormTimeout);
    }
  }, function () {
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true
    }, /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Field, {
      component: FormInput,
      label: intl.formatMessage({
        id: 'auth.emailAddress.label'
      }),
      name: "emailAddressMailingList",
      id: "emailAddressMailingList",
      type: "email",
      disabled: isLoading,
      required: true
    })), /*#__PURE__*/React.createElement(Button, {
      skin: buttonSkin,
      btnType: buttonBtnType,
      block: true,
      type: "submit",
      loading: isLoading,
      loadingMessage: intl.formatMessage({
        id: 'auth.subscribe.loading.label'
      })
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "auth.subscribe.label"
    })));
  }), /*#__PURE__*/React.createElement(FormMailingListNote, null, /*#__PURE__*/React.createElement(Small, {
    color: "muted"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.mailingList.note"
  })))));
};

FormMailingList.defaultProps = {
  inProp: false,
  inPropFeedback: false,
  isLoading: false,
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  feedbackType: undefined,
  feedbackMessage: undefined
};
export default FormMailingList;